import { createFormHook } from '@tanstack/react-form';

import { NumberField } from '@/components/management/formElements/NumberField';
import { SelectField } from '@/components/management/formElements/SelectField';
import { TextField } from '@/components/management/formElements/TextField';
import { fieldContext, formContext } from '@/hooks/useFieldContext';

export const { useAppForm, withFieldGroup } = createFormHook({
  formContext,
  fieldContext,
  fieldComponents: {
    NumberField,
    SelectField,
    TextField,
  },
  formComponents: {},
});
